export default __webpack_public_path__ + "static/media/fuji.c6a7d88d.png";